import { useEffect } from 'react'

const useSetSinkIdPolyfill = () => {
  // Polyfill for setSinkId.
  useEffect(() => {
    if (!('setSinkId' in HTMLAudioElement.prototype)) {
      // eslint-disable-next-line @typescript-eslint/no-extra-semi, @typescript-eslint/no-explicit-any, @typescript-eslint/no-empty-function
      ;(HTMLAudioElement.prototype as any).setSinkId = () => {}
    }
  }, [])
}

export default useSetSinkIdPolyfill
